import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const imageLink = css`
  display: flex;
`;

export const subcategoryList = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  list-style: none;
`;

export const categoryLink = css`
  display: block;
  text-decoration: none;
  color: var(--text-primary);
  &:hover {
    color: var(--brand-dark);
  }
`;

export const categoryLabel = css`
  padding: var(--space-100) 0;

  ${breakpoints.only.mobile} {
    padding: var(--space-85) var(--space-200);
  }
`;

export const category = css`
  display: flex;
  flex-direction: column;

  ${breakpoints.only.mobile} {
    flex-direction: row;
    align-items: flex-start;
    gap: var(--space-200);
  }
`;

export const categoryImage = css`
  width: var(--space-1000);
  height: var(--space-1000);
  margin-bottom: var(--space-100);

  ${breakpoints.only.mobile} {
    width: var(--space-675);
    height: var(--space-675);
    margin-bottom: 0;
  }

  @media (max-width: 320px) {
    width: var(--space-575);
    height: var(--space-575);
  }
`;

export const subcategoryItem = css`
  padding: var(--space-100) 0 !important;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;

  ${breakpoints.only.mobile} {
    padding: var(--space-150) var(--space-200);
  }

  &:hover {
    background-color: inherit !important;
    --button-hover-color: var(--brand-dark) !important;
  }
`;
